import { cur } from '../lib/units';
import { useState } from 'react';
import { Shovel } from 'lucide-react';
import { getGlobalPitPrices, setPitPrice, PIT_MATS, MAT_UNITS, unitLabel } from '../lib/excavation';
import DecIn from './DecIn';

export default function PitPrices({ t }) {
  const [prices, setPrices] = useState(getGlobalPitPrices());
  const upd = (k, patch) => setPrices(setPitPrice(k, patch));
  return (
    <section className="set-sec" data-testid="pit-price-list">
      <h5><Shovel size={14} /> {t.pitPrices}</h5>
      <p className="muted small-hint">{t.pitPriceHint}</p>
      {PIT_MATS.map((k) => (
        <div className="row price-row" key={k} data-testid={`pit-price-row-${k}`}>
          <span className="price-name">{t['pitM_' + k]}</span>
          <DecIn data-testid={`pit-price-input-${k}`} value={prices[k].price ?? ''} placeholder={`${cur()}`} onNum={(n) => upd(k, { price: n })} />
          <select data-testid={`pit-price-unit-${k}`} value={prices[k].unit} onChange={(e) => upd(k, { unit: e.target.value })}>
            {MAT_UNITS[k].map((u) => <option key={u} value={u}>{`${cur()}/${unitLabel(u)}`}</option>)}
          </select>
        </div>
      ))}
    </section>
  );
}
